import { HeroVideoContainer } from "./HeroVideo.styles";

interface IHeroVideo {
  src: string;
  poster: string;
}

const HeroVideo = ({ src, poster }: IHeroVideo) => {
  return (
    <HeroVideoContainer>
      <video
        preload=""
        controls={false}
        src={src}
        muted={true}
        autoPlay={true}
        loop={true}
        playsInline={true}
        poster={poster}
      ></video>
    </HeroVideoContainer>
  );
};

export default HeroVideo;
